//* 오퍼월 SSOT — 벤더 마커와 OS별 지면·인벤토리를 여기서만 관리한다.
//* 혜택 "오늘의 미션"(어드민 placementKey)은 아래 벤더 마커 문자열만 유효하고
//* resolveOfferwallVendor가 이 파일 값으로 분기한다.

export const OFFERWALL_VENDOR = {
  ADPOPCORN: 'adpopcorn',
  ADISON: 'adison',
  PINCRUX: 'pincrux',
} as const;

//* 앱 3.2.0부터 지면키 없이 오퍼월을 바로 열고 identityKey도 붙인다.
//* (앱이 패치 대신 마이너로 범프해 3.1.21은 발행되지 않았다)
export const ADPOPCORN_OFFERWALL_MIN_APP_VERSION = '3.2.0';

//* 3.2.0 미만 앱 폴백용 브릿지 지면 — 그 버전들은 오퍼월 핸들러가 없거나(3.1.15 이하)
//* setUserId를 부르지 않아 브릿지로 열어야 적립이 붙는다. 진입점별 구분은 폐기했으므로 한 쌍만 둔다.
//* 3.2.0 보급이 끝나면 이 상수와 useOpenAdpopcornOfferwall의 브릿지 갈래를 함께 지운다.
export const ADPOPCORN_LEGACY_BRIDGE_PLACEMENT_IDS = {
  android: '9OT0HR3hgIze',
  ios: 'q2ysL5KbViPJ',
} as const;

//* 3.2.0 미만 앱은 오퍼월 핸들러가 inventory를 필수로 요구해 이 호출을 거부한다. 그리고
//* useHandleApp이 실패 응답을 표면화하지 않아 사용자에겐 무반응으로 보인다 — 그래서 아예
//* 비활성 처리해 기존 안내 토스트를 띄운다. 3.2.0 보급이 끝나면 이 상수와 게이트를 지운다.
export const ADISON_OFFERWALL_MIN_APP_VERSION = '3.2.0';

//* 애디슨 오퍼월 진입 시 상단에 노출되는 타이틀. 앱이 SDK에 그대로 넘기므로 여기가 SSOT다 —
//* 앱에 상수로 박으면 변경마다 스토어 빌드가 필요해 웹이 값을 정한다(app-container !49).
//* 미전달 시 SDK 기본값 "바로 적립 받기"가 노출된다.
export const ADISON_OFFERWALL_LIST_TITLE = '이벤트 참여하고 웰포인트 받기';
